import { tv } from 'tailwind-variants';

export const defaultVariants = tv({
  slots: {
    container: ['order-1', 'px-6', 'pt-6', 'pb-4', 'md:pb-0', 'flex', 'flex-col', 'gap-6'],
    loginLabel: [
      'text-textPrimary',
      'text-[27px]',
      'md:text-[24px]',
      'leading-normal',
      'font-semibold',
    ],
    formWrapper: ['flex', 'flex-col', 'ml:pb-4'],
    loginForm: ['flex', 'flex-col', 'gap-4', 'mb-4'],
    formInput: ['border', 'px-3', 'py-1.5', 'rounded', 'text-[#495057] placeholder:text-light-black placeholder:text-[0.875rem]', 'font-semibold'],
    formActions: ['w-full', 'grid', 'grid-cols-2 items-center', 'gap-7.5'],
    forgotLink: [
      'text-secondary',
      'hover:text-primary',
      'text-[16px]',
      'font-semibold',
      'leading-normal',
      'underline',
    ],
    loginDisclaimer: [
      '**:text-[16px]',
      '**:font-semibold',
      '**:leading-6',
      '[&_p]:text-[#6b6b6b]',
      '[&_a]:text-secondary [&_a]:hover:text-primary [&_a]:inline',
    ],
    loginSignUp: [
      '[&_p]:mb-0',
      '**:text-[16px]',
      '**:font-semibold',
      '**:leading-6',
      '[&_p]:text-[#6b6b6b]',
      '[&_a]:text-secondary [&_a]:hover:text-primary',
      'mb-4',
    ],
    logoutButton: [
      'text-primary text-[1.125rem] font-medium md:font-light underline',
      'w-fit mb-4',
      'hover:text-secondary',
    ],
    loginSubmit: [
      'w-full',
      'px-3',
      'py-1.5',
      'min-w-auto',
      'min-h-11.25',
      'text-[16px]',
      'leading-normal',
      'font-semibold',
    ],
  },
});
